import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Layout from "../../../common_comp/Layout/Layout";

function About() {
  return (
    <>
     <Layout>
     <Container className="mt-5 px-4" >


     <Row className="g-5 pt-3">
   
            <Col lg={10} md={10} sm={12} className="mx-auto">
            <h2 className=" fw-bold mb-4">Aim and Scope     </h2>
            <p className="joab-common-para mb-3">
            The Journal of Applied Bioanalysis  <b> (ISSN 2405-710X)  </b>is an full Open Access peer-reviewed journal that publishes scientific articles on all aspects of Bioanalysis. The  <i> Journal of Applied Bioanalysis  </i> provides the bioanalytical chemist with a online forum for publishing different types of scientific communications; including original research, critical reviews, short communications, letter-to-editor and application notes among other article types on the latest relevant developments in the bioanalysis field. The audience of the journal are bioanalytical chemists, academics and technicians working in pharmaceutical sciences, clinical laboratories, (forensic) toxicologists as well sports doping scientists and many other fields applying bioanalysis.


              </p>

            <h2 className=" fw-bold mb-4">Green Publication     </h2>
              <p className="joab-common-para mb-3">
              Green Publication was founded in 2015 and is a privately owned open- access journal publisher.
              </p>

              <h2 className=" fw-bold mb-4">All Content is Open-Access </h2>
              <p className="joab-common-para mb-3">
              Green journals are peer-reviewed Gold open-access, research articles, reviews or any other content is available to everyone free of charge. Open-access (OA) literature is digital, online, free of charge, and free of most copyright and licensing restrictions. To be able to provide open access journals, we finance publication through Article Processing Charges (APC). Authors, funding bodies or institutes usually cover APC. To guarantee high-quality scientific articles we endorse fully the Codes-of-Conducts on Publication Ethics from the COPE organization.<br/>We publish and distribute articles under the terms of the Creative Commons Attribution License 4.0 (CC-BY). The license permits any use, distribution, and reproduction in any medium, but only when the original author(s) and the source receive credit.
              </p>
              
              <h2 className=" fw-bold mb-4">Copyrights </h2>
              <p className="joab-common-para mb-3">
              All Green journals allow the author to retain the copyright in their articles. Articles are instead made available under a Creative Commons licence (CC-BY) to allow others to freely access, copy and use research provided the author is correctly attributed.
              </p>

              <h2 className=" fw-bold mb-4">Green Publication Ethics Statement </h2>
              <p className="joab-common-para mb-3">
              Green takes the responsibility to enforce a rigorous peer-review process. So, together with strict ethical policies and standards, we ensure the publication of high-quality scientific articles. But unfortunately, plagiarism, data falsification, inappropriate authorship credit, still do exist in the field of scientific scholarly publishing. Green Publisher takes publishing ethics very seriously and thus we handle violations with a zero-tolerance policy. To verify the originality of manuscript content, we use iThenticate to check submissions against published materials.
              </p>
              <h2 className=" fw-bold mb-4">Green Publication Malpractice Statement
              </h2>
              <p className="joab-common-para mb-3">
              In cases of alleged or proven scientific misconduct, fraudulent publication, or plagiarism, will take all appropriate measures to clarify the violation. This mostly lead to amendment of the article in question. This includes the prompt publication of a correction statement or erratum or, in the most severe cases, the retraction of the affected work. All articles published by any Green journal will contain a Crossmark stamp. So, using a Crossmark stamp we reassure readers that we’re keeping our published content up-to-date and showcase additional article information in case of an article retraction.metadata.
              </p>
              <p  className="joab-common-para mb-3">Green will follow the advisory guidelines on scientific misconduct from the COPE organization and will thus also act accordingly their guidelines.

</p>
        
            </Col>

          </Row>
      </Container>
     </Layout>
    </>
  );
}

export default About;
